
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Imprint = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container px-4 py-16 mx-auto">
        <div className="max-w-3xl mx-auto space-y-8">
          <Link to="/">
            <Button variant="outline" size="sm">
              Back to Home
            </Button>
          </Link>
          
          <div className="prose prose-gray dark:prose-invert max-w-none">
            <h1 className="text-4xl font-bold mb-8">Imprint</h1>
            
            <p className="text-muted-foreground mb-4">Last updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Company Information</h2>
              <p>causalitas GmbH</p>
              <p>Böblingerstr. 23</p>
              <p>72074 Tübingen</p>
              <p>Germany</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Contact</h2>
              <p>Email: info@causalitas.net</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Legal Information</h2>
              <ul className="list-none pl-0 space-y-2">
                <li>Commercial Register: HRB 794159</li>
                <li>VAT Registration Number: DE367935810</li>
                <li>Authorized Representative: Alexander Janoschka</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Imprint;
